import type { WireRenderer } from "webapp/wire-renderers/wire-renderer";
import "twin.macro";
import { asMaybeString } from "common/computation-model/data";
import { isEmptyOrUndefinedish } from "common/Support";
import React from "react";
import ErrorBoundary from "lib/error-boundary";
import { lazilyLoadedComponent } from "lib/react-lazy-loading";
import type { WireFieldsComponent } from "common/generator/components/fluent-components";
import Img from "webapp/ui/smart/img/img";

const MarkdownView = lazilyLoadedComponent("markdown-view", () => import("../markdown/markdown-view"));

export const Fields: WireRenderer<WireFieldsComponent> = React.memo(props => {
    return (
        <div tw="text-base py-5 px-8 bg-bg-front shadow-md rounded-lg">
            {!isEmptyOrUndefinedish(props.title) && <h2 tw="text-2xl text-text-dark font-bold mb-4">{props.title}</h2>}
            <ul
                tw="list-none grid grid-cols-1 gap-3
                    gp-md:grid-cols-2
                    gp-lg:grid-cols-2
                    gp-xl:grid-cols-3
                    gp-2xl:grid-cols-4">
                {props.fields.map((f, i) => {
                    const v = asMaybeString(f.value?.value);
                    const kind = f.value?.typeKind ?? "string";
                    if (isEmptyOrUndefinedish(v)) return null;
                    let content: React.ReactNode;

                    if (kind === "uri") {
                        content = (
                            <a href={v} target="_blank" rel="noreferrer">
                                {v}
                            </a>
                        );
                    } else if (kind === "image-uri") {
                        content = <Img src={v} tw="max-width[72px] max-height[72px] object-contain rounded-md" />;
                    } else {
                        content = (
                            <ErrorBoundary>
                                <React.Suspense fallback={<div />}>
                                    <MarkdownView tw="p-0!" markdown={v} />
                                </React.Suspense>
                            </ErrorBoundary>
                        );
                    }

                    return (
                        <li key={i}>
                            <div tw="mb-1 text-text-xpale whitespace-pre-wrap break-words">{f.name}</div>
                            {content}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
});
